import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc ActionWidgetNotes defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ActionWidgetNotesService } from 'services/actionWidgetNotes';
 *
 * // create service instance and send/cancel request
 * const actionWidgetNotesService = new ActionWidgetNotesService();
 * const result = await actionWidgetNotesService.fetchData( '<user-id>' ); // fetch data
 * actionWidgetNotesService.cancel(); // cancel an active request
 */
export class ActionWidgetNotesService extends HttpService {

    // fetch call list data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
